import { TariffModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/tariff/tariff.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TariffListOcpiTariffIdCell } from './tariff-list-ocpi-tariff-id.cell';
import { TariffListOcpiTariffIdHeader } from './tariff-list-ocpi-tariff-id.header';

export const TariffListOcpiTariffIdColumn: IdentifiedColumnDef<
  TariffModel,
  TariffModel['ocpiTariffId']
> = {
  enableSorting: false,
  header: TariffListOcpiTariffIdHeader,
  cell: TariffListOcpiTariffIdCell,
};
